export default "__VITE_ASSET__dbef93b6__"